const listeners = new Set()

export const onPersistentReportsChanged = (listener) => {
  if (typeof listener !== 'function') return () => {}
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const emitPersistentReportsChanged = () => {
  listeners.forEach((listener) => {
    try {
      listener()
    } catch (_) {
      // La bandeja no debe interrumpir el flujo del reporte.
    }
  })
}
